import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPSERT_WORKSPACE_KEY_VALUES: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation upsertWorkspaceKeyValues($input: UpsertWorkspaceKeyValuesInput!) {
    upsertWorkspaceKeyValues(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
